import {colorGenerator2, Triangular} from "./Triangular";
import {useEffect, useState} from "react";
import {Logo} from "./Logo";

export function App() {
    const [width, setWidth] = useState<number>(window.innerWidth - 1);
    const [height, setHeight] = useState<number>(window.innerHeight - 1);
    const margin = 0;
    const [logo, setLogo] = useState<number>(Math.min(width, height) * 0.2);

    useEffect(() => {
        window.addEventListener("resize", () => {
            setWidth(window.innerWidth - 1);
            setHeight(window.innerHeight - 1);
            setLogo(Math.min(width, height) * 0.2);
        }, false);
    }, [])

    return (<div style={{
        width: (width + 1) + 'px',
        height: (height + 1) + 'px',
        marginLeft: margin + 'px',
        marginTop: margin + 'px',
        paddingBottom: margin + 'px',
        paddingRight: margin + 'px',
        overflowX: 'hidden',
        overflowY: 'hidden',
    }}>
        <Triangular width={width + 100} height={height + 100} lineHeight={300} pointArea={120}
                    renderingFunction={colorGenerator2} strokeColor={'#272727'} strokeWidth={80}/>
        <div style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <a style={{
                backdropFilter: 'blur(1rem)',
                padding: '15px',
                borderRadius: '50%',
                cursor: 'pointer',
                textDecoration: 'none'
            }} href={'https://gcg-it.ru/'}><Logo height={logo + 'px'} style={{display: 'flex'}}/></a>
        </div>
    </div>);

}
